import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../components/api";
import TransferComponent from "./transfer";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import ExcelSVG from "../../ExcelSVG.svg";
import FilterSVG from "../../FilterSVG.svg";
import * as XLSX from "xlsx";
import Button from "react-bootstrap/Button";
import Formo from "./Editform";
import Modal from "react-bootstrap/Modal";

import AuthContext from "../context/AuthContext";

//For API Requests
import axios from "axios";

function DealerTable() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [transfer, settransfer] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const transferOpen = () => settransfer(true);
  const transferClose = () => settransfer(false);

  const [searchQuery, setSearchQuery] = useState("");
  const { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [filters, setFilters] = useState({
    fullname_en: "",
    phone_number: "",
    balance_usd: "",
    credits: "",
    active_subscriptions: "",
    total_subscriptions: "",
    total_transactions: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const [DealerDetails, setDealerDetails] = useState({
    dealer_id: 0,
    info_id: 0,
    balance: 0,
    first_name: 0,
    middle_name: 0,
    last_name: "",
    phone_number: "",
    address_string: "",
  });

  const updateDealerDetails = (details) => {
    setDealerDetails(details);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/dealers/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.username]);

  const columns = [
    { field: "fullname_en", headerName: "Full Name", flex: 2, minWidth: 250 },
    {
      field: "phone_number",
      headerName: "Phone Number",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "balance_usd",
      headerName: "Balance",
      flex: 1,
      minWidth: 80,
    },
    {
      field: "credits",
      headerName: "Credits",
      type: "number",
      align: "left",
      headerAlign: "left",
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        Number(params.row.credits) || 0,
      valueFormatter: (params) =>
        Number(params.value || 0).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
    {
      field: "active_subscriptions",
      headerName: "Active Subscriptions",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        (Number(params.row.dealer_active_subscriptions) || 0) +
        (Number(params.row.parent_active_subscriptions) || 0),
    },
    {
      field: "total_subscriptions",
      headerName: "Total Subscriptions",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        (Number(params.row.dealer_total_subscriptions) || 0) +
        (Number(params.row.parent_total_subscriptions) || 0),
    },
    {
      field: "total_transactions",
      headerName: "Transactions",
      flex: 1,
      minWidth: 80,
    },

    {
      field: "actions",
      headerName: "Actions",
      minWidth: 200,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                dealer_id: params.row.dealer_id,
                info_id: params.row.info_id,
                first_name: params.row.first_name,
                middle_name: params.row.middle_name,
                last_name: params.row.last_name,
                phone_number: params.row.phone_number,
                balance: params.row.balance_id,
              };
              updateDealerDetails(details);
              handleShow();
            }}
          >
            Details
          </button>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                dealer_id: params.row.dealer_id,
                info_id: params.row.info_id,
                first_name: params.row.first_name,
                middle_name: params.row.middle_name,
                last_name: params.row.last_name,
                phone_number: params.row.phone_number,
                balance: params.row.balance_id,
              };
              updateDealerDetails(details);
              transferOpen();
            }}
          >
            Transfer
          </button>
        </div>
      ),
    },
  ];

  const getRowId = (row) => row.dealer_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchReseller");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchReseller") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchReseller", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchReseller", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Column Headers
  const columnHeaders = {
    fullname_en: "Full Name",
    phone_number: "Phone Number",
    balance_usd: "Balance",
    credits: "Credits",
    active_subscriptions: "Active Subscriptions",
    total_subscriptions: "Total Subscriptions",
    total_transactions: "Transactions",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  /// Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          if (field === "active_subscriptions") {
            transformedRow[headerName] =
              (Number(row.dealer_active_subscriptions) || 0) +
              (Number(row.parent_active_subscriptions) || 0);
          } else if (field === "total_subscriptions") {
            transformedRow[headerName] =
              (Number(row.dealer_total_subscriptions) || 0) +
              (Number(row.parent_total_subscriptions) || 0);
          } else {
            transformedRow[headerName] = row[field] ?? "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Resellers");
    XLSX.writeFile(workbook, "Resellers.xlsx");
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  //Datatable HTML
  return (
    <div className="ClientTable">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Dealer</Modal.Title>
        </Modal.Header>
        <div className="forma">
          <Formo
            sub={DealerDetails.dealer_id}
            info={DealerDetails.info_id}
            balance={DealerDetails.balance}
          />
        </div>
      </Modal>
      <Modal show={transfer} onHide={transferClose} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Transfer Money for {DealerDetails.first_name}{" "}
            {DealerDetails.last_name}{" "}
          </Modal.Title>
        </Modal.Header>
        <div className="forma">
          <TransferComponent
            sub={DealerDetails.dealer_id}
            info={DealerDetails.info_id}
            balance={DealerDetails.balance}
          />
        </div>
      </Modal>
    </div>
  );
}

export default DealerTable;
